<template>
  <div>
    <template v-if="role">
      <DashboardAdmin v-if="role !== 'Pemrakarsa'" />
      <DashboardPemohon v-else />
    </template>
  </div>
</template>

<script>
import DashboardAdmin from './components/Pengendalian/DashboardAdmin.vue'
import DashboardPemohon from './components/Pengendalian/DashboardPemohon.vue'

export default {
  components: {
    DashboardAdmin,
    DashboardPemohon,
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      role: null,
    }
  },
  mounted() {
    if (this.user) {
      this.role = this.user.role
    }
  },
}
</script>
